import isPlainObjectUtil from '../is-plain-object'

export default function mergeObjectUtil (...objects) {
  const mergedObject = {}

  for (const obj of objects) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (isPlainObjectUtil(obj[key])) {
          // Recursively merge nested objects
          mergedObject[key] = mergeObjectUtil(mergedObject[key], obj[key])
        } else {
          mergedObject[key] = obj[key]
        }
      }
    }
  }

  return mergedObject
}
